import { render, staticRenderFns } from "./LeaderBoard2.vue?vue&type=template&id=b2fcb9da&scoped=true&"
import script from "./LeaderBoard2.vue?vue&type=script&lang=js&"
export * from "./LeaderBoard2.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoard2.vue?vue&type=style&index=0&id=b2fcb9da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fcb9da",
  null
  
)

export default component.exports